
document.addEventListener('DOMContentLoaded', function() {
  const video = document.getElementById('custom-video');
  const playPauseBtn = document.getElementById('playPauseBtn');
  const muteToggleBtn = document.getElementById('muteToggle');

  // PLAY / PAUSE toggle
  playPauseBtn.addEventListener('click', function() {
    if (video.paused) {
      video.play();
      playPauseBtn.classList.add('play');
       playPauseBtn.classList.remove('pause');
    } else {
      video.pause();
      playPauseBtn.classList.add('pause');
      playPauseBtn.classList.remove('play');
    }
  });

  // MUTE / UNMUTE toggle
  muteToggleBtn.addEventListener('click', function() {
    video.muted = !video.muted;
    muteToggleBtn.textContent = video.muted ? 'Sound off' : 'Sound on';
  });

  const header = document.querySelector('.password-header');
  if (!header) return;

  window.addEventListener('scroll', function () {
    if (window.scrollY > 10) {
      header.classList.add('is-sticky');
    } else {
      header.classList.remove('is-sticky');
    }
  });

});


document.addEventListener("DOMContentLoaded", function () {
  const linkPro = document.querySelector(".link-pro");
  const salonInput = document.getElementById("SalonName")?.closest(".field");
  const instaInput = document.getElementById("Instagram")?.closest(".field");
  const formWrapper = document.querySelector("form.newsletter-form");

  if (linkPro && salonInput && instaInput && formWrapper) {
    linkPro.addEventListener("click", function (e) {
      e.preventDefault();
      salonInput.style.display = "block";
      instaInput.style.display = "block";

      formWrapper.classList.add("form--pro-visible");

      salonInput.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }
});

